import React from 'react';

import { FormControl, Box, FormHelperText, TextField } from '@mui/material';

export default function RegionNameField({
  value,
  error,
  setValue,
  setError,
  setChanged,
  used_names,
  edit,
}) {
  const handleChange = (event) => {
    const { value: newValue } = event.target;
    setChanged();
    setValue(newValue);
    if (used_names.includes(newValue)) {
      setError('Duplicate Region Name');
    } else if (/[#^$<>+%!`&*'"|{}?/\\:=@]/.test(newValue)) {
      setError('Region name cannot contain #^$<>+%!`&*\'"|{}?/\\:=@');
    } else {
      setError(false);
    }
  };

  return (
    <Box>
      <FormControl fullWidth required>
        <TextField
          label='Region Name'
          id='name'
          aria-describedby='name-helper-text'
          variant='outlined'
          onChange={handleChange}
          error={error}
          value={value}
          disabled={edit}
        />
        {error ? (
          <FormHelperText id='name-helper-text'>{error}</FormHelperText>
        ) : (
          <FormHelperText id='name-helper-text'>
            Enter a name for the region
          </FormHelperText>
        )}
      </FormControl>
    </Box>
  );
}
